import { PropType } from 'vue';
import mixins from 'vue-typed-mixins';

import { CarouselScrolledData } from '@/interfaces/EventBusData';
import { Tab } from '@/interfaces/Tab';
import hashService from '@/services/hash-service';
import { FromComponentTypes } from '@/shared/enums/FromComponentTypes';
import { TabSettingsName } from '@/shared/enums/TabSettingsName';

import { eventBus } from '../event-bus';

export const interactsTabs = mixins().extend({
	props: {
		name: {
			type: String,
			default: ''
		},
		tabs: {
			type: Array as PropType<Tab[]>,
			required: true
		},
		tabGutter: {
			type: Number,
			default: 0
		},
	},
	data() {
		return {
			currentIndex: 0,
		};
	},
	computed: {
		isByUrls(): boolean {
			return !!this.tabs?.[0].url;
		},
		count(): number {
			return this.tabs?.length;
		},
	},
	mounted() {
		this.setState();

		if (!this.isHashEqualCurrent(hashService.currentHash())) return;

		this.currentIndex = this.getTabHashIndex(hashService.currentHash());
		this.toggleTab(this.currentIndex, false, 'mounted');

		eventBus.$on('carousel-scrolled', (data: CarouselScrolledData) => {
			this.toggleTab(data.index, true, 'click', data.fromComponent);
		});
	},
	watch: {
		tabs: {
			handler() {
				if(this.name === TabSettingsName.ADDONS
					|| this.name === TabSettingsName.TARIFF_OPTIONS
					|| this.name === TabSettingsName.ADDITIONAL_SERVICES)
					this.toggleTab(this.currentIndex, false, 'mounted');
			}
		}
	},
	methods: {
		setState(): void {
			this.tabs.forEach((tab: Tab, i: number) => {
				tab.state = !this.isByUrls ? !i : this.isCurrentUrl(tab.url);
			});
		},
		toggleTab(index: number, setHash: boolean, eventType: string, fromComponent?: string): void {
			this.tabs.forEach((tab: Tab, i: number) => {
				tab.state = i === index;

				if (this.isByUrls && i === index)
					window.location.href = tab.url;
			});

			if (setHash && !this.isByUrls)
				hashService.setHash({ tab: this.name + '-' + index });

			this.currentIndex = eventType === 'mounted' ? this.getTabHashIndex(hashService.currentHash()) : index;

			if (fromComponent !== FromComponentTypes.CAROUSEL)
			  eventBus.$emit('tab-toggled', { index, fromComponent: FromComponentTypes.TABS });
		},
		isHashEqualCurrent(hash: { [index: string]: string }): boolean {
			if (!hash.tab) return false;

			return (new RegExp('\\b' + this.name + '\\b')).test(hash.tab);
		},
		getTabHashIndex(hash: { [index: string]: string }): number {
			const index = hash.tab?.match(/\d+$/)?.[0];
			return index === undefined ? 0 : +index;
		},
		isCurrentUrl(url: string): boolean {
			return window.location.pathname === url;
		}
	},
});
